import React from 'react';

import { useEmailSubscriptionFormState } from '@hooks/useEmailSubscriptionFormState';
import { FormField, LoaderButton, Paragraph as P, TextField } from '@periodica/ui-kit';
import logo from '@images/icons/logo-blue.svg';
import { StatusMessage } from '@periodica/ui-kit';

import { BlockContainer } from '@components/MainPage/components/BlockContainer';

import subscribePhoto from '@images/subscribePhoto.png';

import * as Checkbox from '@periodica/ui-kit/checkbox';

import gtm from '@periodica/analytics/gtm';
import enkod from '@periodica/analytics/enkod';

import { SubscribeAgreementText } from '@components/SubscribeAgreeementText';

import * as styles from './Subscribe.module.css';

export function Subscribe() {
  const {
    email,
    setEmail,
    emailError,
    formStatus,
    submit,
    setAgreePolicy,
    agreePolicy,
    agreePolicyError,
  } = useEmailSubscriptionFormState({
    onSubmit: () => {
      gtm.logEvent({ name: 'custom_subscribe_email_static' });

      setAgreePolicy(false);
      enkod.setUser({ email });
    },
    options: {
      static: true,
    },
  });

  return (
    <BlockContainer>
      <div className={styles.mainPart}>
        <div className={styles.leftPart}>
          <div className={styles.imageBlock}>
            <img src={subscribePhoto} alt="subscribePhoto" />
          </div>
        </div>

        <div className={styles.rightPart}>
          <div className={styles.rightContentBlock}>
            <div className={styles.logoBlock}>
              <img src={logo} alt="logo" />
            </div>
            <div className={styles.rightUnderPart}>
              {formStatus === 'submitted' ? (
                <div className={styles.submittedText}>
                  <P size="large">Готово! Спасибо за подписку!</P>
                  <P size="large">
                    Письмо с подтверждением уже у вас на почте. Загляните в&nbsp;&laquo;Спам&raquo;,
                    если письмо не приходит.
                  </P>
                </div>
              ) : (
                <>
                  <P size="large">
                    Подпишитесь на нашу рассылку. <br /> Только важное, никакого спама. <br /> Бонус
                    за подписку: гайд с идеями для фотокниг
                  </P>
                  <form className={styles.formPart} onSubmit={submit}>
                    <FormField name="email" error={emailError === undefined ? '' : emailError}>
                      <TextField
                        name="email"
                        variant="white"
                        value={email}
                        onChange={setEmail}
                        placeholder="E-mail"
                      />
                    </FormField>
                    <LoaderButton
                      variant="primary"
                      type="submit"
                      size="large"
                      loading={formStatus === 'submitting'}
                    >
                      Хочу получать письма
                    </LoaderButton>

                    {!email ||
                      (agreePolicyError && !agreePolicy && (
                        <StatusMessage>{agreePolicyError}</StatusMessage>
                      ))}

                    <Checkbox.SingleCheckbox
                      size="medium"
                      label={<SubscribeAgreementText />}
                      checked={agreePolicy}
                      onChange={setAgreePolicy}
                    />
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </BlockContainer>
  );
}
